import(/* webpackMode: "eager" */ "/var/www/turivana/frontend/src/app/[locale]/acerca/page.tsx");
